import type { MapperImageOptions, MapperOptions } from '#layers/core/types'
import imageSizes from '~/constants/imageSizes'
import { mapperGlobalDataTheme } from '~/data-layer/global-data/mappers'
import {
  mapperModuleInternalVideo,
  mapperModuleMedia,
  mapperModuleNavigationLink,
  mapperModuleVideo
} from '~/data-layer/modules/mappers'

const mapMedia = (item: any, imageOptions: MapperImageOptions) => {
  const contentType = item?.contentType || 'ModuleMedia'

  switch (contentType) {
    case 'ModuleMedia': {
      return { image: mapperModuleMedia(item, imageOptions) }
    }
    case 'ModuleVideo': {
      return { video: mapperModuleVideo(item, imageOptions) }
    }
    case 'ModuleInternalVideo': {
      return { video: mapperModuleInternalVideo(item, imageOptions) }
    }
    default: {
      return {}
    }
  }
}
export const mapperBlockLandscapeMediaThenContent = (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }

  const fallBackImageSizes = imageSizes.columns12_5269

  const fallbackImageOptions = {
    lazy: true,
    sizes: fallBackImageSizes
  }

  return {
    contentType: data.contentType || '',
    id: data.sys?.id || '',
    sys: data.sys || null,
    title: data.title || '',
    description: data.blockLandscapeMediaThenContentDescription || null,
    ...mapMedia(data.media, options.imageOptions || fallbackImageOptions),
    link: mapperModuleNavigationLink(data.link, options.getUrl),
    theme: mapperGlobalDataTheme(data.sectionTheme)?.theme || null
  }
}
